import { Component, OnInit, Input } from '@angular/core';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

@Component({
    selector: 'xqnr-feature-list',
    templateUrl: './feature-list.component.pug',
    styleUrls: ['./feature-list.component.scss'],
    standalone: false
})
export class FeatureListComponent implements OnInit {
  @Input() items: any[];

  fa = {
    checkCircle: faCheckCircle,
  };

  constructor() {}
  ngOnInit() {}
}
